import {useCallback, useEffect, useLayoutEffect, useRef, useState} from "react";
import {newsDetail, newsList, reservationCode, reservationSubmit} from "../api/api";
import shareIcon from "../assets/images/mobile/nav/nav_menu_share.svg";
import drawerIcon from "../assets/images/mobile/nav/nav_menu_drawer.svg";
import musicOffIcon from "../assets/images/mobile/nav/nav_btn_audio_off.svg";
import musicOnIcon from "../assets/images/mobile/nav/nav_btn_audio_on.svg";
import userIcon from "../assets/images/mobile/nav/nav_btn_user.svg";
import socialXhsIcon from "../assets/images/mobile/nav/nav_link_xhs.svg";
import socialWbIcon from "../assets/images/mobile/nav/nav_link_wb.svg";
import fuVoice from "../assets/audio/fu.mp3";
import suVoice from "../assets/audio/su.mp3";
import luVoice from "../assets/audio/lu.mp3";
import peiVoice from "../assets/audio/pei.mp3";
import socialBiliIcon from "../assets/images/mobile/nav/nav_link_bili.svg";
import socialDyIcon from "../assets/images/mobile/nav/nav_link_dy.svg";
import socialTapIcon from "../assets/images/mobile/nav/nav_link_tap.svg";
import ArticleScreen from "./components/ArticleScreen";
import MobileLegalScreen from "./components/MobileLegalScreen";
import CharacterDetailScreen from "./components/CharacterDetailScreen";
import CharacterListScreen from "./components/CharacterListScreen";
import FeatureScreen from "./components/FeatureScreen";
import HomeScreen from "./components/HomeScreen";
import NewsScreen from "./components/NewsScreen";
import MobileFooter from "./components/MobileFooter";
import ReservationModal from "./components/ReservationModal";
import {mobileImage} from "./mobileAssets";
import "./styles/mobile.css";

const PUBLIC_URL = process.env.PUBLIC_URL || "";
const CDN_BASE_URL = (process.env.REACT_APP_CDN_BASE_URL || PUBLIC_URL).replace(/\/$/, "");
const BG_MUSIC_URL = process.env.REACT_APP_BG_MUSIC_URL || `${CDN_BASE_URL}/audio/bg-music.mp3`;
const HERO_VIDEO_URL = process.env.REACT_APP_HERO_VIDEO_URL || `${PUBLIC_URL}/videos/home-v1.mp4`;

const characters = [
    {card: "P2_02.png", hero: "oneuser.png", nameEn: "namee.png", name: "P2_03.png", description: "我会一直在你身边。", audio: fuVoice},
    {card: "mobiles_11.jpg", hero: "oneuser1.png", nameEn: "namee1.png", name: "P2_07.png", description: "相信我。在你面前，我绝无虚假。", audio: suVoice},
    {card: "mobiles_12.jpg", hero: "oneuser2.png", nameEn: "namee2.png", name: "P2_14.png", description: "要怎样做……才不会失去你？", audio: luVoice},
    {card: "mobiles_14.jpg", hero: "oneuser3.png", nameEn: "namee3.png", name: "P2_16.png", description: "只要能再一次……见到你。", audio: peiVoice}
];

const features = ["three_02.png", "three2.jpg", "three3.jpg", "three4.jpg"];

const newsItems = [
    {category: "公告", title: "《失乐枷锁》一测招募开启", date: "2026.9.9", tab: "notice"},
    {category: "公告", title: "《失乐枷锁》首测PV：渴慕与沉浮", date: "2026.9.9", tab: "notice"},
    {category: "公告", title: "公平运营声明", date: "2026.9.9", tab: "notice"},
    {category: "公告", title: "更多游戏资讯敬请期待", date: "2026.9.9", tab: "notice"}
];

const navigation = [
    {id: "home", label: "首 页", labelEn: "H O M E"},
    {id: "characters", label: "角色介绍", labelEn: "C H A R A C T E R"},
    {id: "features", label: "游戏特色", labelEn: "F E A T U R E S"},
    {id: "news", label: "新闻公告", labelEn: "N E W S"}
];

const mainViewIds = navigation.map(function (item) { return item.id; });
const phoneRegexp = /^1[3-9]\d{9}$/;
const initialReservationForm = {phone: "", code: "", agreed: true, platforms: []};

function getMobileLegalType() {
    const match = (window.location.hash || "").match(/^#\/(user-agreement|privacy-policy|contact-us)/);
    return match ? match[1] : null;
}

const socialLinks = [
    {id: "xhs", label: "小红书", href: "https://xhslink.cn/m/13nXyy3KB16", icon: socialXhsIcon},
    {id: "wb", label: "微博", href: "https://weibo.com/u/7965573423", icon: socialWbIcon},
    // {id: "bili", label: "哔哩哔哩", href: "https://b23.tv/Eqh08pJ", icon: socialBiliIcon},
    {id: "dy", label: "抖音", href: "https://v.douyin.com/4T_ACjPELgo/", icon: socialDyIcon},
    {id: "tap", label: "TapTap", href: "https://www.taptap.cn/user/755350585", icon: socialTapIcon}
];

function setMobileRem() {
    const pageWidth = (document.body && document.body.clientWidth) || document.documentElement.offsetWidth;
    const ratio = pageWidth / 960;
    const widthProportion = ratio > 1 ? 1 : (ratio < 0.32 ? 0.32 : ratio);
    document.documentElement.style.setProperty("font-size", `${widthProportion * 100}px`, "important");
}

function setMobileViewportHeight() {
    const activeElement = document.activeElement;
    const isReservationInputFocused = activeElement
        && activeElement.matches(".mobile-reservation-modal input[type='tel'], .mobile-reservation-modal input[type='text']");
    if (isReservationInputFocused) return;

    const viewport = window.visualViewport;
    const viewportHeight = viewport
        ? Math.min(window.innerHeight, viewport.height)
        : window.innerHeight;
    if (viewportHeight > 0) {
        document.documentElement.style.setProperty("--mobile-vh", `${viewportHeight}px`);
    }
}

function mountLegacyStyles() {
    const stylesheets = [
        {id: "mobile-reset-css", href: `${PUBLIC_URL}/mobile/css/reset.css`},
        {id: "mobile-source-css", href: `${PUBLIC_URL}/mobile/css/css.css`}
    ];

    return stylesheets.map(function (stylesheet) {
        const existing = document.getElementById(stylesheet.id);
        if (existing) return existing;
        const link = document.createElement("link");
        link.id = stylesheet.id;
        link.rel = "stylesheet";
        link.href = stylesheet.href;
        document.head.appendChild(link);
        return link;
    });
}

function normalizeIndex(index, length) {
    return (index + length) % length;
}

export default function MobileApp() {
    const [activeView, setActiveView] = useState("home");
    const [activeCharacter, setActiveCharacter] = useState(0);
    const [activeFeature, setActiveFeature] = useState(0);
    const [activeArticle, setActiveArticle] = useState(null);
    const [activeLegal, setActiveLegal] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isShareOpen, setIsShareOpen] = useState(false);
    const [isMusicOn, setIsMusicOn] = useState(true);
    const [reservationStage, setReservationStage] = useState(null);
    const [reservationForm, setReservationForm] = useState(initialReservationForm);
    const [codeCountdown, setCodeCountdown] = useState(0);
    const [reservationMessage, setReservationMessage] = useState("");
    const [isCodeLoading, setIsCodeLoading] = useState(false);
    const [isReservationSubmitting, setIsReservationSubmitting] = useState(false);
    const [reservedPhone, setReservedPhone] = useState("");
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [mobileNewsItems, setMobileNewsItems] = useState(newsItems);
    const [isMobileNewsLoading, setIsMobileNewsLoading] = useState(true);
    const [isArticleLoading, setIsArticleLoading] = useState(false);
    const [activeArticleDetail, setActiveArticleDetail] = useState(null);
    const sectionPagesRef = useRef(null);
    const sectionRefs = useRef({});
    const bgMusicRef = useRef(null);
    const musicEnabledRef = useRef(true);
    const voicePlaybackActiveRef = useRef(false);

    useEffect(() => {
        let alive = true;
        async function loadMobileNews() {
            setIsMobileNewsLoading(true);
            try {
                const response = await newsList({limit: 30});
                const result = response && response.data;
                const items = result && result.code === 0 && result.data && Array.isArray(result.data.items)
                    ? result.data.items
                    : null;
                if (alive && items) {
                    setMobileNewsItems(items.map(function (item) {
                        return {...item, category: item.category || "公告", date: item.date || item.datetime || "", tab: item.tab || "notice"};
                    }));
                }
            } catch (error) {
                // Keep the bundled news list available when the API is unavailable.
            } finally {
                if (alive) setIsMobileNewsLoading(false);
            }
        }
        loadMobileNews();
        return () => { alive = false; };
    }, []);

    useEffect(() => {
        if (activeView !== "article" || !activeArticle || !activeArticle.id) return undefined;
        let alive = true;
        setIsArticleLoading(true);
        async function loadMobileNewsDetail() {
            try {
                const response = await newsDetail({id: activeArticle.id});
                const result = response && response.data;
                if (alive && result && result.code === 0 && result.data) setActiveArticleDetail(result.data);
            } catch (error) {
                // The list item remains visible if detail loading fails.
            } finally {
                if (alive) setIsArticleLoading(false);
            }
        }
        loadMobileNewsDetail();
        return () => { alive = false; };
    }, [activeView, activeArticle]);

    useEffect(() => {
        const styleLinks = mountLegacyStyles();
        const handleStylesheetLoad = function () {
            setMobileRem();
            setMobileViewportHeight();
        };
        document.documentElement.classList.add("mobile-app-active");
        document.body.classList.add("mobile-app-active");
        styleLinks.forEach(function (link) {
            link.addEventListener("load", handleStylesheetLoad);
        });
        setMobileRem();
        setMobileViewportHeight();
        window.addEventListener("resize", setMobileRem);
        window.addEventListener("resize", setMobileViewportHeight);
        if (window.visualViewport) window.visualViewport.addEventListener("resize", setMobileViewportHeight);

        return () => {
            window.removeEventListener("resize", setMobileRem);
            window.removeEventListener("resize", setMobileViewportHeight);
            if (window.visualViewport) window.visualViewport.removeEventListener("resize", setMobileViewportHeight);
            styleLinks.forEach(function (link) {
                link.removeEventListener("load", handleStylesheetLoad);
            });
            document.documentElement.classList.remove("mobile-app-active");
            document.body.classList.remove("mobile-app-active");
            document.documentElement.style.removeProperty("font-size");
            document.documentElement.style.removeProperty("--mobile-vh");
            styleLinks.forEach(function (link) { link.remove(); });
        };
    }, []);

    useEffect(() => {
        const syncHashRoute = function () {
            const legalType = getMobileLegalType();
            if (legalType) {
                setActiveLegal(legalType);
                setActiveView("legal");
            } else if (activeView === "legal") {
                setActiveView("home");
            }
        };
        syncHashRoute();
        window.addEventListener("hashchange", syncHashRoute);
        return () => window.removeEventListener("hashchange", syncHashRoute);
    }, [activeView]);

    useEffect(() => {
        if (!isMenuOpen) return undefined;
        const handleKeyDown = function (event) {
            if (event.key === "Escape") setIsMenuOpen(false);
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isMenuOpen]);

    useEffect(() => {
        if (!reservationStage) return undefined;
        const handleKeyDown = function (event) {
            if (event.key === "Escape") setReservationStage(null);
        };
        document.documentElement.classList.add("mobile-reservation-open");
        document.body.classList.add("mobile-reservation-open");
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            document.documentElement.classList.remove("mobile-reservation-open");
            document.body.classList.remove("mobile-reservation-open");
            setMobileViewportHeight();
        };
    }, [reservationStage]);

    useEffect(() => {
        if (codeCountdown <= 0) return undefined;
        const timerId = window.setInterval(function () {
            setCodeCountdown(function (value) { return Math.max(0, value - 1); });
        }, 1000);
        return () => window.clearInterval(timerId);
    }, [codeCountdown]);

    useEffect(() => {
        const bgMusic = bgMusicRef.current;
        if (!bgMusic) return undefined;
        bgMusic.volume = 0.45;

        const syncMusicState = function () {
            setIsMusicOn(!bgMusic.paused);
        };
        const tryPlayMusic = function () {
            if (!musicEnabledRef.current || voicePlaybackActiveRef.current) return;
            if (!bgMusic.paused) {
                setIsMusicOn(true);
                removePlaybackListeners();
                return;
            }
            bgMusic.play().then(function () {
                setIsMusicOn(true);
                removePlaybackListeners();
            }).catch(function () {
                setIsMusicOn(false);
            });
        };
        const removePlaybackListeners = function () {
            window.removeEventListener("pointerdown", tryPlayMusic, true);
            window.removeEventListener("touchstart", tryPlayMusic, true);
            window.removeEventListener("keydown", tryPlayMusic, true);
            bgMusic.removeEventListener("canplay", tryPlayMusic);
        };

        bgMusic.addEventListener("play", syncMusicState);
        bgMusic.addEventListener("pause", syncMusicState);
        bgMusic.addEventListener("canplay", tryPlayMusic);
        tryPlayMusic();
        window.addEventListener("pointerdown", tryPlayMusic, true);
        window.addEventListener("touchstart", tryPlayMusic, true);
        window.addEventListener("keydown", tryPlayMusic, true);

        return () => {
            bgMusic.removeEventListener("play", syncMusicState);
            bgMusic.removeEventListener("pause", syncMusicState);
            removePlaybackListeners();
        };
    }, []);

    useEffect(() => {
        const previousScrollRestoration = window.history.scrollRestoration;
        const resetToFirstSection = function () {
            if (getMobileLegalType()) return;
            const container = sectionPagesRef.current;
            if (container) container.scrollTop = 0;
            setActiveView("home");
        };

        window.history.scrollRestoration = "manual";
        resetToFirstSection();
        const frameId = window.requestAnimationFrame(resetToFirstSection);
        const timerId = window.setTimeout(resetToFirstSection, 120);
        window.addEventListener("pageshow", resetToFirstSection);

        return () => {
            window.cancelAnimationFrame(frameId);
            window.clearTimeout(timerId);
            window.removeEventListener("pageshow", resetToFirstSection);
            window.history.scrollRestoration = previousScrollRestoration;
        };
    }, []);

    useLayoutEffect(() => {
        if (!["characterDetail", "article", "legal"].includes(activeView)) return undefined;
        const container = sectionPagesRef.current;
        if (!container) return undefined;
        container.style.scrollBehavior = "auto";
        container.scrollTop = 0;
        container.scrollTo({top: 0, left: 0, behavior: "auto"});
        const frameId = window.requestAnimationFrame(function () {
            if (sectionPagesRef.current) {
                sectionPagesRef.current.scrollTop = 0;
                sectionPagesRef.current.scrollTo({top: 0, left: 0, behavior: "auto"});
                sectionPagesRef.current.style.scrollBehavior = "";
            }
        });
        return () => window.cancelAnimationFrame(frameId);
    }, [activeView]);

    const showView = function (view, options = {}) {
        if (mainViewIds.includes(view) && getMobileLegalType()) {
            window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}`);
            setActiveLegal(null);
        }
        setActiveView(view);
        setIsMenuOpen(false);

        if (mainViewIds.includes(view)) {
            window.requestAnimationFrame(function () {
                const section = sectionRefs.current[view];
                if (section) section.scrollIntoView({behavior: options.instant ? "auto" : "smooth", block: "start"});
            });
        }
    };

    const handleSectionScroll = function (event) {
        const container = event.currentTarget;
        if (!container.clientHeight) return;
        const sectionIndex = Math.round(container.scrollTop / container.clientHeight);
        const nextView = mainViewIds[Math.max(0, Math.min(mainViewIds.length - 1, sectionIndex))];
        if (nextView && nextView !== activeView) setActiveView(nextView);
    };

    const handleShare = function () {
        setIsMenuOpen(false);
        setIsShareOpen(true);
    };

    const handleMusicToggle = function () {
        const bgMusic = bgMusicRef.current;
        if (!bgMusic) return;

        if (bgMusic.paused) {
            musicEnabledRef.current = true;
            bgMusic.play().then(function () {
                setIsMusicOn(true);
            }).catch(function () {
                setIsMusicOn(false);
            });
        } else {
            musicEnabledRef.current = false;
            bgMusic.pause();
            setIsMusicOn(false);
        }
    };

    const handleCharacterVoiceStart = useCallback(function () {
        const bgMusic = bgMusicRef.current;
        voicePlaybackActiveRef.current = true;
        if (!bgMusic || !musicEnabledRef.current) return false;
        if (!bgMusic.paused) bgMusic.pause();
        setIsMusicOn(false);
        return true;
    }, []);

    const handleCharacterVoiceEnd = useCallback(function (shouldRestoreMusic) {
        voicePlaybackActiveRef.current = false;
        if (!shouldRestoreMusic || !musicEnabledRef.current) return;
        const bgMusic = bgMusicRef.current;
        if (!bgMusic) return;
        bgMusic.play().then(function () {
            setIsMusicOn(true);
        }).catch(function () {
            setIsMusicOn(false);
        });
    }, []);

    const openCharacter = function (index) {
        setActiveCharacter(index);
        showView("characterDetail");
    };

    const changeCharacter = function (offset) {
        setActiveCharacter(function (index) { return normalizeIndex(index + offset, characters.length); });
    };

    const changeFeature = function (offset) {
        setActiveFeature(function (index) { return normalizeIndex(index + offset, features.length); });
    };

    const openArticle = function (article) {
        setActiveArticle(article);
        setActiveArticleDetail(null);
        showView("article");
    };

    const openReservation = function () {
        setIsUserMenuOpen(false);
        setReservationForm(initialReservationForm);
        setCodeCountdown(0);
        setReservationMessage("");
        setReservationStage("form");
    };

    const updateReservationField = function (field, value) {
        setReservationForm(function (form) { return {...form, [field]: value}; });
    };

    const toggleReservationPlatform = function (platform) {
        setReservationForm(function (form) {
            const platforms = form.platforms.includes(platform)
                ? form.platforms.filter(function (item) { return item !== platform; })
                : [...form.platforms, platform];
            return {...form, platforms};
        });
    };

    const handleSendCode = async function () {
        if (!phoneRegexp.test(reservationForm.phone) || codeCountdown > 0 || isCodeLoading) return;
        setIsCodeLoading(true);
        setReservationMessage("");
        try {
            const response = await reservationCode({phone: reservationForm.phone});
            const result = response && response.data;
            if (!result || result.code !== 0) {
                setReservationMessage((result && result.message) || "验证码获取失败，请稍后再试");
                return;
            }
            setCodeCountdown((result.data && result.data.cooldown) || 60);
            setReservationMessage("验证码已发送，请输入后完成预约");
        } catch (error) {
            setReservationMessage("验证码获取失败，请稍后再试");
        } finally {
            setIsCodeLoading(false);
        }
    };

    const handleReservationSubmit = async function (event) {
        event.preventDefault();
        const isComplete = phoneRegexp.test(reservationForm.phone)
            && /^\d{6}$/.test(reservationForm.code)
            && reservationForm.agreed
            && reservationForm.platforms.length > 0;
        if (!isComplete || isReservationSubmitting) return;
        setIsReservationSubmitting(true);
        setReservationMessage("");
        try {
            const response = await reservationSubmit({
                platform: reservationForm.platforms.join(","),
                platforms: reservationForm.platforms,
                phone: reservationForm.phone,
                code: reservationForm.code
            });
            const result = response && response.data;
            if (!result || result.code !== 0) {
                setReservationMessage((result && result.message) || "预约失败，请稍后再试");
                return;
            }
            setReservedPhone(reservationForm.phone);
            setReservationStage("success");
        } catch (error) {
            setReservationMessage("预约失败，请稍后再试");
        } finally {
            setIsReservationSubmitting(false);
        }
    };

    const handleUserClick = function () {
        if (!reservedPhone) {
            openReservation();
            return;
        }
        setIsUserMenuOpen(function (value) { return !value; });
    };

    const handleUserLogout = function () {
        setReservedPhone("");
        setIsUserMenuOpen(false);
    };

    const character = characters[activeCharacter];
    const isMainView = mainViewIds.includes(activeView);
    const isReservationComplete = phoneRegexp.test(reservationForm.phone)
        && /^\d{6}$/.test(reservationForm.code)
        && reservationForm.agreed
        && reservationForm.platforms.length > 0;

    return (
        <div className="content_mobile mobile-app">
            <div className="header">
              {activeView !== "legal" && activeView !== "article" && !isMenuOpen ? <img src={mobileImage("topbg_01.png")} className="logobg" alt="失乐枷锁"/> : null}
                <button className="mobile-logo-button" type="button" onClick={() => showView("home")} aria-label="返回首页">
                    <img src={mobileImage("nav_logo.png")} className="logo" alt="失乐枷锁"/>
                </button>
                <div className="tools">
                    <button className="mobile-tool-button" type="button" onClick={handleShare} aria-label="分享页面"><img src={shareIcon} className="icon share" alt=""/></button>
                    <button className="mobile-tool-button" type="button" onClick={handleMusicToggle} aria-label={isMusicOn ? "关闭音乐" : "打开音乐"}><img src={isMusicOn ? musicOnIcon : musicOffIcon} className="icon mus" alt=""/></button>
                    <div className="mobile-user-wrap">
                        <button className="mobile-tool-button" type="button" onClick={handleUserClick} aria-label="用户中心" aria-expanded={isUserMenuOpen}><img src={userIcon} className="icon user" alt=""/></button>
                        {isUserMenuOpen && reservedPhone ? <div className="mobile-user-popover" role="menu"><span>{reservedPhone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2")}</span><button type="button" onClick={handleUserLogout}>退出</button></div> : null}
                    </div>
                    <button className={isMenuOpen ? "menu mobile-menu-toggle is-open" : "menu mobile-menu-toggle"} type="button" onClick={() => setIsMenuOpen((value) => !value)} aria-label={isMenuOpen ? "关闭导航" : "打开导航"} aria-expanded={isMenuOpen}><img src={isMenuOpen ? mobileImage("closex_03.png") : drawerIcon} alt=""/></button>
                </div>
            </div>

            <nav className={isMenuOpen ? "mobile-menu is-open" : "mobile-menu"} aria-hidden={!isMenuOpen}>
                <div className="mobile-menu-links">
                    {navigation.map(function (item) {
                        return <button key={item.id} className={activeView === item.id ? "is-active" : ""} type="button" onClick={() => showView(item.id)}><span>{item.label}</span><small>{item.labelEn}</small></button>;
                    })}
                </div>
                <img src={mobileImage("fbgs_02.jpg")} className="bgs" alt=""/>
                <div className="mobile-menu-socials" aria-label="社交平台">
                    {socialLinks.map(function (item, index) {
                        return <a key={item.id} className={`mobile-menu-social-link mobile-menu-social-link-${index + 1}`} href={item.href} target="_blank" rel="noreferrer" aria-label={item.label}><img src={item.icon} alt=""/></a>;
                    })}
                </div>
            </nav>

            {isShareOpen ? (
                <div className="mobile-follow-mask" role="dialog" aria-modal="true" aria-labelledby="mobileFollowTitle" onClick={() => setIsShareOpen(false)}>
                    <section className="mobile-follow-modal" onClick={(event) => event.stopPropagation()}>
                        <header>
                            <h2 id="mobileFollowTitle">前往关注</h2>
                            <button type="button" className="mobile-follow-close" onClick={() => setIsShareOpen(false)} aria-label="关闭弹窗"><img src={mobileImage("closex_03.png")} alt=""/></button>
                        </header>
                        <div className="mobile-follow-links">
                            {socialLinks.map(function (item) {
                                return <a key={item.id} href={item.href} target="_blank" rel="noreferrer" aria-label={item.label}><img src={item.icon} alt=""/></a>;
                            })}
                        </div>
                    </section>
                </div>
            ) : null}

            <div key={isMainView ? "main" : activeView} ref={sectionPagesRef} className={isMainView ? "content_page mobile-section-pages" : activeView === "characterDetail" ? "content_page character-detail-scroll" : activeView === "legal" ? "content_page mobile-legal-scroll" : "content_page"} onScroll={isMainView ? handleSectionScroll : undefined}>
                {isMainView && (
                    <>
                        <HomeScreen ref={(node) => { sectionRefs.current.home = node; }} onReserve={openReservation} onShowCharacters={() => showView("characters")}/>
                        <CharacterListScreen ref={(node) => { sectionRefs.current.characters = node; }} characters={characters} onOpenCharacter={openCharacter}/>
                        <FeatureScreen ref={(node) => { sectionRefs.current.features = node; }} features={features} activeFeature={activeFeature} onChangeFeature={changeFeature}/>
                        <NewsScreen ref={(node) => { sectionRefs.current.news = node; }} newsItems={mobileNewsItems} isLoading={isMobileNewsLoading} onOpenArticle={openArticle}/>
                        <MobileFooter/>
                    </>
                )}

                {activeView === "characterDetail" && (
                    <>
                        <CharacterDetailScreen character={character} characterIndex={activeCharacter} videoSrc={HERO_VIDEO_URL} onChangeCharacter={changeCharacter} onBack={() => showView("characters", {instant: true})} onVoiceStart={handleCharacterVoiceStart} onVoiceEnd={handleCharacterVoiceEnd}/>
                        <MobileFooter/>
                    </>
                )}

                {activeView === "article" && (
                    <ArticleScreen article={activeArticleDetail || activeArticle} isLoading={isArticleLoading} onBack={() => showView("news")}/>
                )}

                {activeView === "legal" && (
                    <MobileLegalScreen type={activeLegal}/>
                )}
            </div>

            <ReservationModal stage={reservationStage} form={reservationForm} codeCountdown={codeCountdown} isComplete={isReservationComplete} message={reservationMessage} isCodeLoading={isCodeLoading} isSubmitting={isReservationSubmitting} onClose={() => setReservationStage(null)} onFieldChange={updateReservationField} onPlatformToggle={toggleReservationPlatform} onSendCode={handleSendCode} onSubmit={handleReservationSubmit}/>
            <audio ref={bgMusicRef} src={BG_MUSIC_URL} loop preload="auto" autoPlay playsInline/>
        </div>
    );
}
